"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapToTargetAlphabetKeyIsDown = void 0;
var map_to_target_key_is_down_1 = require("./map-to-target-key-is-down");
var mapToTargetAlphabetKeyIsDown = function (key) {
    return (0, map_to_target_key_is_down_1.mapToTargetKeyIsDown)(key);
};
exports.mapToTargetAlphabetKeyIsDown = mapToTargetAlphabetKeyIsDown;
